export const ProtectedRoute = ({ children }) => {
  // useEffect(() => {
  //   if (!isLoggedIn()) {
  //     console.log(location);
  //     navigate('/auth/sign-in', { state: { from: location.pathname } });
  //   }
  // }, []);

  return children;
};
